var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAddGroceryList(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-195 -1026.5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(93.68 936.18)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(101.32 90.32)",
    fill: "#e8716d",
    stroke: "#e8716d",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 13,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 13,
    cy: 13,
    r: 11.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    transform: "translate(-135.111 1015.41)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(334.611 17)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M96.832,89.7H94.017a.267.267,0,0,0-.267.267v6.431H97.1V89.964A.267.267,0,0,0,96.832,89.7Z",
    transform: "translate(-87.119 -89.161)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75,100.224a3.349,3.349,0,0,1,6.7,0Z",
    transform: "translate(-73.393 -94.416)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.43,96.875h-6.162a.268.268,0,0,0-.268.268v3.081h6.7V97.143A.268.268,0,0,0,106.43,96.875Z",
    transform: "translate(-91.695 -94.416)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("rect", {
    width: 16.61,
    height: 1.674,
    rx: 0.837,
    transform: "translate(0 5.808)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M87,115.625H72l.634,5.282a1.608,1.608,0,0,0,1.6,1.416H84.773a1.608,1.608,0,0,0,1.6-1.416Z",
    transform: "translate(-71.196 -108.143)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    y1: 4.554,
    transform: "translate(8.305 8.554)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    y1: 4.554,
    transform: "translate(4.956 8.554)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    y1: 4.554,
    transform: "translate(11.654 8.554)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x2: 1.674,
    transform: "translate(13.328 4.133)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 0.89,
    transform: "translate(7.86)",
    fill: "#fff",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4.119 8.554)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.212,119.625h0a.837.837,0,0,0-.837.837v2.88a.837.837,0,0,0,.837.837h0a.837.837,0,0,0,.837-.837v-2.88A.837.837,0,0,0,85.212,119.625Z",
    transform: "translate(-84.375 -119.625)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.712,119.625h0a.837.837,0,0,0-.837.837v2.88a.837.837,0,0,0,.837.837h0a.837.837,0,0,0,.837-.837v-2.88A.837.837,0,0,0,97.712,119.625Z",
    transform: "translate(-93.526 -119.625)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.212,119.625h0a.837.837,0,0,0-.837.837v2.88a.837.837,0,0,0,.837.837h0a.837.837,0,0,0,.837-.837v-2.88A.837.837,0,0,0,110.212,119.625Z",
    transform: "translate(-102.677 -119.625)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.019,90.394a2.045,2.045,0,0,1-2.368-2.368,2.045,2.045,0,0,1,2.368,2.368Z",
    transform: "translate(-76.063 -87.935)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.769 0.536)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M98.536,95.5a.536.536,0,0,1-.379-.915l4.736-4.736a.536.536,0,0,1,.758.758l-4.736,4.736A.533.533,0,0,1,98.536,95.5Z",
    transform: "translate(-98 -89.697)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeWidth: 0.7
  })), /*#__PURE__*/React.createElement("path", {
    d: "M81.74,102.875a3.32,3.32,0,0,0-.49,1.741",
    transform: "translate(-77.968 -98.809)",
    fill: "#e8716d",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 0.7
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddGroceryList);
export default __webpack_public_path__ + "static/media/add-grocery-list.61e983ae.svg";
export { ForwardRef as ReactComponent };